const baseUrl = "/dev";

export const DEVELOPERS_API_URLS= {
    ROOMS:  baseUrl + "/rooms",
    TOKENS: baseUrl + "/tokens",
    USER:   baseUrl + "/developer",
    OAUTH:  baseUrl + "/oauth",
};